import { render } from "./InstanceComments.vue?vue&type=template&id=0ff1f270"
import script from "./InstanceComments.vue?vue&type=script&lang=js"
export * from "./InstanceComments.vue?vue&type=script&lang=js"

import "./InstanceComments.vue?vue&type=style&index=0&id=0ff1f270&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__